const MOMENT_FORMATS = {
  MONTH_DAYS_COMMA_YEAR: 'MMM DD, YYYY',
  HOURS_MINUTES: 'HH:mm',
  DATE_FORMATS: 'DD MMM YYYY, HH:mm',
  FILE_DATE_FORMATS: 'DD-MM-YYYY HH.mm.ss'
}

export { MOMENT_FORMATS }
export default MOMENT_FORMATS
